import type { UseFormReturn } from "react-hook-form";
import type { ThemeClasses } from "../types";
import type { Device } from "../../../../../../store/admin/devicesStore";
import type { User } from "../../../../../../store/admin/usersStore";
import Modal from "../../../../../../components/base/Modal";
import { GroupForm, type GroupFormData } from "./GroupForm";

interface GroupModalProps {
  isOpen: boolean;
  isEdit: boolean;
  loadingSubmit: boolean;
  form: UseFormReturn<GroupFormData>;
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  devices: Device[];
  devicesLoading?: boolean;
  devicesInitialLoading?: boolean;
  onDevicesMenuScrollToBottom?: () => void;
  monitoristas: User[];
  monitoristasLoading?: boolean;
  onSubmit: (data: GroupFormData) => void;
  onClose: () => void;
}

export function GroupModal({
  isOpen,
  isEdit,
  loadingSubmit,
  form,
  themeClasses,
  isDarkMode,
  devices,
  devicesLoading,
  devicesInitialLoading,
  onDevicesMenuScrollToBottom,
  monitoristas,
  monitoristasLoading,
  onSubmit,
  onClose,
}: GroupModalProps) {
  if (!isOpen) return null;

  return (
    <Modal
      title={isEdit ? "Editar Grupo" : "Nuevo Grupo"}
      onClose={onClose}
      themeClasses={themeClasses}
      width="w-full max-w-[550px]"
      content={
        <GroupForm
          form={form}
          isEdit={isEdit}
          loadingSubmit={loadingSubmit}
          themeClasses={themeClasses}
          isDarkMode={isDarkMode}
          devices={devices}
          devicesLoading={devicesLoading}
          devicesInitialLoading={devicesInitialLoading}
          onDevicesMenuScrollToBottom={onDevicesMenuScrollToBottom}
          monitoristas={monitoristas}
          monitoristasLoading={monitoristasLoading}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      }
    />
  );
}
